/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

const SourceTypes = {
  GETTING_READY: 'gettingReadyResults',
  READY: 'readyResults',
  SPRINT: 'sprintResults',
  COMPLETED: 'completedResults',
  ACCEPTED: 'acceptedResults',
  SHIPPING: 'shippingResults',
  PROGRESS: 'progressTasks',
  ACTIVITY: 'activity'
};

export default SourceTypes;
